/* Szyfron — landing page */

(function () {
  "use strict";

  /* ---- Nawigacja: cień/obrys po przewinięciu ---- */
  var nav = document.getElementById("nav");

  function onScroll() {
    if (!nav) return;
    nav.classList.toggle("is-scrolled", window.scrollY > 8);
  }

  window.addEventListener("scroll", onScroll, { passive: true });
  onScroll();

  /* ---- Menu mobilne ---- */
  var toggle = document.getElementById("navToggle");
  var links = document.getElementById("navLinks");

  if (toggle && links) {
    toggle.addEventListener("click", function () {
      var open = links.classList.toggle("is-open");
      toggle.classList.toggle("is-open", open);
      toggle.setAttribute("aria-expanded", open ? "true" : "false");
    });

    // Zamknij po kliknięciu w link
    links.addEventListener("click", function (e) {
      if (e.target.tagName !== "A") return;
      links.classList.remove("is-open");
      toggle.classList.remove("is-open");
      toggle.setAttribute("aria-expanded", "false");
    });
  }

  /* ---- Pojawianie się sekcji przy przewijaniu ---- */
  var revealables = document.querySelectorAll("[data-reveal]");

  if (!("IntersectionObserver" in window)) {
    // Starsze przeglądarki: pokaż wszystko od razu.
    revealables.forEach(function (el) {
      el.classList.add("is-visible");
    });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry, i) {
        if (!entry.isIntersecting) return;

        // Delikatne kaskadowe wejście elementów w tej samej sekcji.
        var delay = Math.min(i * 70, 280);
        setTimeout(function () {
          entry.target.classList.add("is-visible");
        }, delay);

        observer.unobserve(entry.target);
      });
    },
    { threshold: 0.12, rootMargin: "0px 0px -60px 0px" }
  );

  revealables.forEach(function (el) {
    // Elementy, które są już w kadrze albo powyżej niego (wejście z linkiem
    // typu #cennik, przywrócona pozycja przewijania), nigdy nie wywołałyby
    // obserwatora — odsłaniamy je od razu.
    if (el.getBoundingClientRect().top < window.innerHeight) {
      el.classList.add("is-visible");
      return;
    }

    observer.observe(el);
  });
})();
